import { usePlayerStatistics } from '@/api/players';
import { ModalsKey } from '@/enums/modalsKey';
import { PlayerPrivacyModeId } from '@/models/player/privacy-mode/id';
import { ModalWithVersion } from '../core/Modal/WithVersion';
import ProfileModalContent from './Content';
import RankedBadge from './RankedBadge';

export default function ProfileModal() {
  const { player, isPending, error } = usePlayerStatistics();
  const isVisiblePlayer: boolean =
    !!player &&
    player?.privacyModeId?.toString() ===
      PlayerPrivacyModeId.Public?.toString();

  return (
    <ModalWithVersion
      title={player?.username ?? ''}
      modal={ModalsKey.UserProfile}
      noPadding
      isLoading={isPending}
      condition={isPending || !!error ? true : isVisiblePlayer}
    >
      <RankedBadge />
      <ProfileModalContent />
    </ModalWithVersion>
  );
}
